import type { OrganicProduct, Product, SponsoredProduct } from '@shared/types/types.ts';

/**
 *
 */
const SPONSORED_POSITIONS = [1, 2, 8, 16, 24, 32, 40, 48, 56, 64, 72];

/**
 *
 *
 */
const MAX_PRODUCTS = 120;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function interleave(sponsoredProducts: SponsoredProduct[], organicProducts: OrganicProduct[]): Product[] {
    const result: Product[] = [];
    let sponsoredIndex = 0;
    let organicIndex = 0;

    for (const targetPosition of SPONSORED_POSITIONS) {
        if (sponsoredIndex >= sponsoredProducts.length) {
            break;
        }

        const organicNeeded = targetPosition - 1 - result.length;
        const organicAvailable = organicProducts.length - organicIndex;

        if (organicNeeded > organicAvailable) {
            break;
        }

        if (organicNeeded > 0) {
            result.push(...organicProducts.slice(organicIndex, organicIndex + organicNeeded));
            organicIndex += organicNeeded;
        }

        result.push(sponsoredProducts[sponsoredIndex]);
        sponsoredIndex++;
    }

    if (organicIndex < organicProducts.length) {
        const remainingSlots = MAX_PRODUCTS - result.length;
        const organicsToAdd = Math.min(remainingSlots, organicProducts.length - organicIndex);
        result.push(...organicProducts.slice(organicIndex, organicIndex + organicsToAdd));
    }

    return result;
}
